import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Anchor, Button } from "grommet";
import { Account } from "../utils/AccountStore";
import SkeletonWrapper from "./SkeltonWrapper";
import { Questionnaire, IsRenderable } from "../utils/ServiceManagerAPI";
import React, { useEffect, useState } from "react";
import { Document, Page } from "react-pdf";
import { Attachment } from "./AttachmentUpload";
import StyledModal from "./StyledModel";
import axios from "../utils/HttpClient";

const downloadAttachment = async (attachment) => {
    try {
        const response = await axios.get(`${ServiceManagerUrl}api/Attachments/${attachment.id}`, {
            responseType: "blob", // Important for handling file downloads
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", attachment.name); // or dynamically set the file name
        document.body.appendChild(link);
        link.click();
        link.remove(); // Remove the element after download
    } catch (error) {
        console.error("Error downloading the attachment", error);
    }
};

const RenderAttachments = ({ questionnaire, attachments, user, deleteAttachment }: { questionnaire?: Questionnaire; attachments: Attachment[]; user: Account; deleteAttachment?: Function }) => {
    const [showAttachment, setShowAttachment] = useState(false);
    const [selectedAttachment, setSelectedAttachment] = useState<Attachment>();

    const select = (attachment: Attachment) => {
        setSelectedAttachment(attachment);
        setShowAttachment(true);
        if (IsRenderable(attachment.contentType)) {
            setLoading(true);
        }
    };

    const [loading, setLoading] = useState(false);

    const toggleAttachmentModal = () => {
        if (showAttachment) {
            setSelectedAttachment(undefined);
        }
        setShowAttachment(!showAttachment);
    };

    const [pages, setPages] = useState(0);

    const doDelete = () => {
        if (selectedAttachment) {
            deleteAttachment && deleteAttachment(selectedAttachment.questionID, selectedAttachment.id);
        }
        toggleAttachmentModal();
    };

    const [attachmentUrl, setAttachmentUrl] = useState("");

    useEffect(() => {
        const fetchAttachment = async (id) => {
            try {
                const response = await axios.get(`${ServiceManagerUrl}api/Attachments/${id}`, {
                    responseType: "blob", // important for binary data,
                });

                const url = window.URL.createObjectURL(new Blob([response.data]));
                setAttachmentUrl(url);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching the attachment", error);
                setLoading(false);
            }
        };

        if (selectedAttachment?.id) {
            fetchAttachment(selectedAttachment.id);
        }
    }, [selectedAttachment]);

    return (
        <>
            <Box gap={"small"}>
                {attachments?.map((attachment, attachmentKey) => (
                    <Box direction="row" key={attachment.id}>
                        <Box gap="small">
                            <Anchor label={attachment.name} color="brand" icon={<FontAwesomeIcon icon={["fad", "file"]}></FontAwesomeIcon>} onClick={() => select(attachment)}></Anchor>
                        </Box>
                    </Box>
                ))}
            </Box>

            <StyledModal isOpen={showAttachment} setIsOpen={() => toggleAttachmentModal()}>
                {selectedAttachment && (
                    <Box width={"large"} gap={"small"}>
                        <Anchor onClick={() => downloadAttachment(selectedAttachment)}>Download {selectedAttachment.name}</Anchor>
                        {!questionnaire?.locked && deleteAttachment && selectedAttachment.userID == user.id && <Button label="Delete Attachment" color="status-critical" icon={<FontAwesomeIcon icon={["fad", "trash-can"]} />} onClick={() => doDelete()}></Button>}
                        {IsRenderable(selectedAttachment.contentType) && (
                            <>
                                {selectedAttachment.contentType == "application/pdf" && (
                                    <Document
                                        file={attachmentUrl}
                                        onLoadSuccess={({ numPages }: { numPages: number }) => {
                                            setPages(numPages);
                                            setLoading(false);
                                        }}
                                    >
                                        {Array.from(new Array(pages), (el, index) => (
                                            <Page pageNumber={index + 1} renderTextLayer={false} renderAnnotationLayer={false} width={750} />
                                        ))}
                                    </Document>
                                )}
                                {selectedAttachment.contentType != "application/pdf" && <object onLoad={() => setLoading(false)} data={attachmentUrl} type={selectedAttachment.contentType} width="100%" height="100%"></object>}
                                <SkeletonWrapper loading={loading}>
                                    <></>
                                </SkeletonWrapper>
                            </>
                        )}
                    </Box>
                )}
            </StyledModal>
        </>
    );
};

export default RenderAttachments;
